module.exports = __webpack_public_path__ + "static/city-car-44e17b894afeee2a7d5fc98fda39f900.jpg";